module.exports = __webpack_public_path__ + "img/s_2.a7298cd7.png";